import React, { Component } from "react";
import "./Person.css";
import { Link } from "react-router-dom";
import { Breadcrumb, Alert, PageHeader, Glyphicon } from "react-bootstrap";
import ListPersons from "./ListPersons";
import NewPerson from "./NewPerson";
import Joyride from 'react-joyride';

export default class Person extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      showAlertSuccess: false,
      showAlertError: false,
      alertMessage: '',
      refreshPersons: false,
      runJoy: false,
      steps: [
    	  {
          target: '.createPerson',
          content: 'Acá puedes mostrar el formulario para crear una nueva persona.',
          placement: 'top'
        },
        {
          target: '.react-bs-table-container',
          content: 'Puedes filtrar los tickets de soporte.',
          placement: 'top'
        },
        {
          target: '.actions',
          content: 'Acciones que deseas realizar con el registro (Modificar o Eliminar).',
          placement: 'top'
        },
        {
          target: '.loadMore',
          content: 'Si haces click aquí se cargarán mas tickets.',
          placement: 'top'
        },
        {
          target: '.btnRefresh',
          content: 'Actualiza la lista de tus tickets.',
          placement: 'bottom'
        }
      ]
    };
  }

  handleAlertSuccess = (message) => {
	var newState = { alertMessage: message.message, showAlertSuccess: true };
	if (message.refresh) {
	  newState.refreshPersons = true;
	}
	this.setState(newState);
	setTimeout(function() { 
      if(this.state.showAlertSuccess){
        this.setState({ showAlertSuccess: false });
      }
    }.bind(this), 3000);
  }
  
  handleDismissSuccess = () => {
	this.setState({ showAlertSuccess: false });
  }

  handleAlertError = (message) => {
    this.setState({ alertMessage: message.message, showAlertError: true });
    setTimeout(function() { 
      if(this.state.showAlertError){
        this.setState({ showAlertError: false });
      }
    }.bind(this), 3000);
  }
  
  handleDismissError = () => {
	this.setState({ showAlertError: false });
  }

  handleHelp = () => {
    this.setState({ runJoy: true});
  }
  
  render() {
    const { steps, runJoy } = this.state;
    return (
      <div className="Person">
        <Joyride
          steps={steps}
          run={runJoy}
          continuous={true}
          scrollToFirstStep={true}
          callback={this.callback}
          locale={{ back: 'Atrás', close: 'Cerrar', last: 'Finalizar', next: 'Siguiente', skip: 'Saltar' }}
        />
        <Breadcrumb>
        	<Breadcrumb.Item componentClass={Link} href="/" to="/">Home</Breadcrumb.Item>
	        <Breadcrumb.Item active>Personas</Breadcrumb.Item>
          <Glyphicon className="help" glyph="info-sign" onClick={this.handleHelp} />
	    </Breadcrumb>
        <PageHeader>
          Personas <small>Configuración</small>
        </PageHeader>
        <NewPerson className="createPerson" {...this.props} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
        {
        	this.state.showAlertSuccess &&
        	<Alert bsStyle="success" onDismiss={this.handleDismissSuccess}>
        	  <strong>{this.state.alertMessage}</strong>
        	</Alert>
        }
        {
        	this.state.showAlertError &&
        	<Alert bsStyle="danger" onDismiss={this.handleDismissError}>
        	  <strong>{this.state.alertMessage}</strong>
        	</Alert>
        }
        <ListPersons {...this.props} refresh={this.state.refreshPersons} onAlertSuccess={this.handleAlertSuccess} onAlertError={this.handleAlertError}/>
      </div>
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/containers/person/Person.js